import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import RouteWithLayoutV2 from './components/RouteWithLayoutV2';
import { jornadaListUrl, JORNADA_FORM_ID_NOVO } from '../helpers/jornadaHelpers';
import { MainV2 as MainV2Layout, MinimalV2 as MinimalV2Layout } from './components/layouts';
import {
  LoginV2 as LoginView,
  ConvocacaoV2 as ConvocacaoView,
  PedidoVooV2 as PedidoVooView,
  RequisicoesV2 as RequisicoesView,
  OleriteV2 as OleriteView,
  NotasV2 as NotasView,
  CartoesV2 as CartoesView,
  InspecaoVeicularV2 as InspecaoVeicularView,
  MalhasV2 as MalhasView,
  GerenciasV2 as GerenciasView,
  PolosV2 as PolosView,
  SubestacoesV2 as SubestacoesView,
  AlimentadoresV2 as AlimentadoresView,
  DocumentosV2 as DocumentosView,
  AportesV2 as AportesView,
  AporteUsuarioV2 as AporteUsuarioView,
  EstoqueV2 as EstoqueView,
  EstoquePedidosV2 as EstoquePedidosView,
  EstoqueProdutosV2 as EstoqueProdutosView,
  OdometrosV2 as OdometrosView,
  ProgramacaoDiariaDiaV2 as ProgramacaoDiariaDiaView,
  IntegracoesV2 as IntegracoesView,
  RelatorioDigitacaoV2 as RelatorioDigitacaoView,
  MinhaDigitacaoV2 as MinhaDigitacaoView,
  RelatorioInspecaoV2 as RelatorioInspecaoView,
  RelatorioUsoMutuoV2 as RelatorioUsoMutuoView,
  VeiculosV2 as VeiculosView,
  ControleFrequenciaV2 as ControleFrequenciaView,
  FolhaPontoV2 as FolhaPontoV2View,
  JornadaV2 as JornadaView,
  JornadaMedicaoV2 as JornadaMedicaoView,
  ControlePontoV2 as ControlePontoV2View,
  ControleCaixaV2 as ControleCaixaV2View,
  EquipamentosV2 as EquipamentosView,
  NsirsV2 as NsirsView,
  NsirV2 as NsirView,
  ProcedimentoNormaV2 as ProcedimentoNormaView,
  RelatorioVeiculoV2 as RelatorioVeiculoView,
  RelatorioJornadaV2 as RelatorioJornadaView,
  NsirMapaV2 as NsirMapaView,
  RelatorioFinanceiroV2 as RelatorioFinanceiroView,
  DronesV2 as DronesView,
  DashboardV2 as DashboardView,
  UsuariosV2 as UsuariosView,
  UsuarioDocumentoCertificadoV2 as UsuarioDocumentoCertificadoView,
  MeuPerfilV2 as MeuPerfilView,
  CalendarioV2 as CalendarioView,
  CalendarioAdminV2 as CalendarioAdminView,
  DownloadsV2 as DownloadsView,
} from '../views/v2';

const RoutesV2 = ({ match, modeSetting, resolvedMode, onModeSettingChange }) => (
  <>
    <RouteWithLayoutV2
      component={LoginView}
      exact
      isPublic
      layout={MinimalV2Layout}
      path={`${match.path}/login`}
      componentProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
    />
    <RouteWithLayoutV2
      component={ConvocacaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/convocacoes`}
    />
    <RouteWithLayoutV2
      component={PedidoVooView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/pedidos-voo`}
    />
    <RouteWithLayoutV2
      component={RequisicoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/requisicoes`}
    />
    <RouteWithLayoutV2
      component={OleriteView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/olerites`}
    />
    <RouteWithLayoutV2
      component={NotasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/notas`}
    />
    <RouteWithLayoutV2
      component={CartoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/cartoes`}
    />
    <RouteWithLayoutV2
      component={InspecaoVeicularView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/inspecoes-veiculares`}
    />
    <RouteWithLayoutV2
      component={MalhasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/malhas`}
    />
    <RouteWithLayoutV2
      component={GerenciasView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/gerencias`}
    />
    <RouteWithLayoutV2
      component={PolosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/polos`}
    />
    <RouteWithLayoutV2
      component={SubestacoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/subestacoes`}
    />
    <RouteWithLayoutV2
      component={AlimentadoresView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/alimentadores`}
    />
    <RouteWithLayoutV2
      component={DocumentosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/documentos`}
    />
    <RouteWithLayoutV2
      component={AportesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/aportes`}
    />
    <RouteWithLayoutV2
      component={AporteUsuarioView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/aporte/:usuarioId`}
    />
    <RouteWithLayoutV2
      component={EstoqueView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoques`}
    />
    <RouteWithLayoutV2
      component={EstoquePedidosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoque/pedidos`}
    />
    <RouteWithLayoutV2
      component={EstoqueProdutosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/estoque/produtos`}
    />
    <RouteWithLayoutV2
      component={OdometrosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/odometros`}
    />
    <Route
      exact
      path={`${match.path}/programacao-diaria`}
      render={({ location }) => (
        <Redirect
          to={{
            pathname: `${match.path}/programacao-diaria-dia`,
            search: location.search,
          }}
        />
      )}
    />
    <RouteWithLayoutV2
      component={ProgramacaoDiariaDiaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/programacao-diaria-dia`}
    />
    <RouteWithLayoutV2
      component={IntegracoesView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/integracoes`}
    />
    <RouteWithLayoutV2
      component={RelatorioDigitacaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-digitacao`}
    />
    <Route
      exact
      path={`${match.path}/relatorio-digitacao-nova`}
      render={({ location }) => (
        <Redirect
          to={{
            pathname: `${match.path}/relatorio-digitacao`,
            search: location.search,
          }}
        />
      )}
    />
    <RouteWithLayoutV2
      component={MinhaDigitacaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/minha-digitacao`}
    />
    <RouteWithLayoutV2
      component={MinhaDigitacaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/digitacao/digitador/:digitadorId`}
    />
    <Route
      exact
      path={`${match.path}/minha-digitacao-nova`}
      render={() => <Redirect to={`${match.path}/minha-digitacao`} />}
    />
    <RouteWithLayoutV2
      component={RelatorioInspecaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-inspecao`}
    />
    <RouteWithLayoutV2
      component={RelatorioUsoMutuoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-uso-mutuo`}
    />
    <RouteWithLayoutV2
      component={VeiculosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/veiculos`}
    />
    <RouteWithLayoutV2
      component={RelatorioVeiculoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-veiculo`}
    />
    <RouteWithLayoutV2
      component={RelatorioJornadaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-jornada`}
    />
    <RouteWithLayoutV2
      component={RelatorioFinanceiroView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/relatorio-financeiro`}
    />
    <RouteWithLayoutV2
      component={ControleFrequenciaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/controle-frequencia`}
    />
    <RouteWithLayoutV2
      component={JornadaMedicaoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/jornada-medicao`}
    />
    <Route
      exact
      path={`${match.path}/jornada-medicao/:id`}
      render={({ location, match: routeMatch }) => (
        <Redirect
          to={jornadaListUrl(
            `${match.path}/jornada-medicao`,
            location.search,
            routeMatch.params.id,
          )}
        />
      )}
    />
    <RouteWithLayoutV2
      component={FolhaPontoV2View}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/folha-pontos`}
    />
    <RouteWithLayoutV2
      component={JornadaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/jornada`}
    />
    <Route
      exact
      path={`${match.path}/jornada/novo`}
      render={({ location }) => (
        <Redirect
          to={jornadaListUrl(
            `${match.path}/jornada`,
            location.search,
            JORNADA_FORM_ID_NOVO,
          )}
        />
      )}
    />
    <Route
      exact
      path={`${match.path}/jornada/:id`}
      render={({ location, match: routeMatch }) => (
        <Redirect
          to={jornadaListUrl(
            `${match.path}/jornada`,
            location.search,
            routeMatch.params.id,
          )}
        />
      )}
    />
    <RouteWithLayoutV2
      component={EquipamentosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/equipamentos`}
    />
    <RouteWithLayoutV2
      component={ControlePontoV2View}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/controle-ponto`}
    />
    <RouteWithLayoutV2
      component={ControleCaixaV2View}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/controle-caixa`}
    />
    <RouteWithLayoutV2
      component={ProcedimentoNormaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/procedimentos-normas`}
    />
    <RouteWithLayoutV2
      component={NsirsView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/nsirs`}
    />
    <RouteWithLayoutV2
      component={NsirMapaView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/nsirs/mapa`}
    />
    <RouteWithLayoutV2
      component={NsirView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/nsir`}
    />
    <RouteWithLayoutV2
      component={NsirView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/nsir/:nsirId`}
    />
    <RouteWithLayoutV2
      component={CalendarioView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/calendario`}
    />
    <RouteWithLayoutV2
      component={CalendarioAdminView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/calendario-admin`}
    />
    <RouteWithLayoutV2
      component={UsuariosView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/usuarios`}
    />
    <RouteWithLayoutV2
      component={UsuarioDocumentoCertificadoView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/usuarios-documentos`}
    />
    <RouteWithLayoutV2
      component={MeuPerfilView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/meu-perfil`}
    />
    <RouteWithLayoutV2
      component={DownloadsView}
      exact
      layout={MainV2Layout}
      layoutProps={{
        modeSetting,
        resolvedMode,
        onModeSettingChange,
      }}
      path={`${match.path}/downloads`}
    />
    <RouteWithLayoutV2
      component={DronesView}
      exact
      layout={MainV2Layout}
      layoutProps={{ modeSetting, resolvedMode, onModeSettingChange }}
      path={`${match.path}/drones`}
    />
    <RouteWithLayoutV2
      component={DashboardView}
      exact
      layout={MainV2Layout}
      layoutProps={{ modeSetting, resolvedMode, onModeSettingChange }}
      path={`${match.path}/dashboard`}
    />
  </>
);

RoutesV2.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  modeSetting: PropTypes.oneOf(['system', 'light', 'dark']).isRequired,
  resolvedMode: PropTypes.oneOf(['light', 'dark']).isRequired,
  onModeSettingChange: PropTypes.func.isRequired,
};

export default RoutesV2;
